export default class FormValidationError {
    constructor({ message, hint }) {
        this.message = message;
        this.hint = hint;
    }
}
